// import { BiListUl, BiLogoReact, BiRename } from "react-icons/bi";
import { BiListUl, BiRename } from "react-icons/bi";

import { FaReact } from "react-icons/fa";


export const tenantProvisioningCardData = [
    {
        title: 'Automated Provisioning',
        subTitle: `Our guided process will handle all the technical steps for you Sit back and watch your tenant get configured in minutes.`,
        isRecommended: true,
        icon: <BiListUl />,
        buttonValue: 'AP'

    },
    {
        title: 'Semi Automated (PowerShell)',
        subTitle: `Follow Semi-Automated steps for a semi automated setup using our PowerShell Script.`,
        isRecommended: false,
        icon: <FaReact />,
        buttonValue: 'SAP'


    },
    {
        title: 'Fully Manual Configuration',
        subTitle: `For user who want to perform every steps manually inside the Microsoft 365 Admin Portal.`,
        isRecommended: false,
        icon: <BiRename />,
        buttonValue: 'MP'

    }
]